import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { selectBuyNowSkuHistory } from '@/Application/Selectors/buyNow/useBuyNowCart';
import type { ClientPreference } from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';
import {
  initializeSkuHistory,
  updateSkuHistory
} from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';

export const useBuyNowSkuHistory = () => {
  const dispatch = useAppDispatch();
  const skuHistory = useAppSelector(selectBuyNowSkuHistory);

  const initializeSku = useCallback(
    (sku: string) => {
      dispatch(initializeSkuHistory(sku));
    },
    [dispatch]
  );

  const updateClientPreference = useCallback(
    (clientPreference: ClientPreference) => {
      dispatch(updateSkuHistory(clientPreference));
    },
    [dispatch]
  );

  const getSkuHistory = useCallback(() => {
    return skuHistory ?? { sku: '', clientPreference: [] };
  }, [skuHistory]);

  return {
    skuHistory,
    initializeSku,
    updateClientPreference,
    getSkuHistory
  };
};
